import { BaseAnalyticsProvider } from '../../BaseAnalyticsProvider'

export default class Mixpanel extends BaseAnalyticsProvider {
	constructor(configuration: any) {
		super()
	}

	public async sendEvent() {}
}
